import SidebarsMainTemplate from './SidebarsMainTemplate';

export default SidebarsMainTemplate;
